module.exports = __webpack_public_path__ + "static/media/盈联社区.be387c89.jpeg";